import { IInitialState } from 'store/models';
import { surveysStateSelector } from './surveysStateSelector';

export function isOfficesAndLimitsDataLoadingSelector(state: IInitialState) {
	return surveysStateSelector(state)?.isOfficesAndLimitsDataLoading;
}
